import stringPrice from "Helpers/stringPrice";
import React from "react";
import NotFoundImage from "../../../Assets/Images/not-found.jpg";
import * as Styled from "./styles";
import { useHistory } from "react-router";

interface Props {
  title: string;
  category: string;
  subcategory: string;
  image: string;
  slug: string;
  price?: any;
  oldPrice?: any;
  link: any;
  stock?: any;
  flex?: any;
  tagHighlight?: boolean;
}

const AdListItem: React.FC<Props> = ({
  title,
  category,
  image,
  subcategory,
  slug,
  price,
  oldPrice,
  link,
  stock,
  flex,
  tagHighlight,
}) => {
  const history = useHistory();

  return (
    <Styled.Container
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        history.push(link);
      }}
    >
      <div style={{ flex: 1, marginTop: 10, position: "relative" }}>
        {image ? (
          <Styled.ProductImage src={image} alt="Product image" />
        ) : (
          <Styled.ProductImage src={NotFoundImage} alt="not found image" />
        )}
        {tagHighlight && (
          <Styled.TagHighlight>
            <Styled.TagText>DESTAQUE</Styled.TagText>
          </Styled.TagHighlight>
        )}
        {category && (
          <Styled.Category
            style={{ marginLeft: 14, marginRight: 14, marginTop: 14 }}
          >
            {
              <a href={`/produtos/`}>{`${
                category.length + subcategory.length > 32
                  ? `${category.slice(0, 15)}...`
                  : category
              }`}</a>
            }
          </Styled.Category>
        )}
        <Styled.Title
          style={{ marginLeft: 14, marginRight: 14, marginTop: 10 }}
        >
          <a
            style={
              flex
                ? {
                    textDecoration: "none",
                    overflow: "hidden",
                    display: "block",
                    width: "100%",
                  }
                : {
                    textDecoration: "none",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "block",
                    width: "100%",
                  }
            }
            href={`/produto/${slug}`}
          >
            {`${
              title.length > 18 && flex ? `${title.substring(0, 15)}...` : title
            }`}
          </a>
        </Styled.Title>
        <Styled.Unity style={{ marginLeft: 14, marginRight: 14 }}>
          {stock ? `${stock} no estoque` : ""}
        </Styled.Unity>
        <Styled.InfoPrice style={{ marginLeft: 14, marginRight: 4 }}>
          <Styled.PriceActual>
            {price ? `${stringPrice(price / 100)}` : "Sob Consulta"}
          </Styled.PriceActual>
        </Styled.InfoPrice>
      </div>
      <Styled.SeeMoreInformation style={{ marginTop: 24 }}>
        <Styled.DividerHorizontal />
        <div
          style={{
            width: "100%",
            height: "36px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Styled.LinkSeeMode href={`/produto/${slug}`}>
            VER DETALHES
          </Styled.LinkSeeMode>
        </div>
      </Styled.SeeMoreInformation>
    </Styled.Container>
  );
};

export default AdListItem;
